import { render, staticRenderFns } from "./dash.vue?vue&type=template&id=099639fd&"
import script from "./dash.vue?vue&type=script&lang=ts&"
export * from "./dash.vue?vue&type=script&lang=ts&"
import style0 from "./dash.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports